var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1874 1.74006H15.0632C16.6737 1.74006 18 3.09345 18 4.73684V15.0032C18 16.6466 16.6926 18 15.0632 18H2.93684C1.32632 18 0 16.666 0 15.0032V4.73684C0 3.09345 1.30737 1.74006 2.93684 1.74006H4.79368V0.792696C4.79368 0.348013 5.13474 0 5.57053 0C6.00632 0 6.34737 0.367347 6.34737 0.792696V1.74006H11.6526V0.792696C11.6526 0.367347 11.9747 0 12.4105 0C12.8463 0 13.1874 0.367347 13.1874 0.792696V1.74006ZM4.81269 3.30613H2.9369C2.16005 3.30613 1.53479 3.94415 1.53479 4.73685V7.05694H16.4653V4.73685C16.4653 3.94415 15.8401 3.30613 15.0632 3.30613H13.2253V4.2535C13.2253 4.69818 12.8843 5.04619 12.4485 5.04619C12.0127 5.04619 11.6716 4.67885 11.6716 4.2535V3.30613H6.36637V4.2535C6.36637 4.69818 6.02532 5.04619 5.58953 5.04619C5.15374 5.04619 4.81269 4.67885 4.81269 4.2535V3.30613Z",
    fill: "#C3CBD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2c6f9db7d922b2e1276166e3f4c370cd.svg";
export { ForwardRef as ReactComponent };